import React, { useEffect } from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import {useAppSelector, useAppDispatch} from '../store/hooks';
import {clearSkipFlag} from '../store/features/pages/pageSlice';
import ResultRecommendation from '../components/Results/ResultRecommendation';
import ResultModel from '../components/Results/ResultModel';
import { ResultModel as ResultModelType } from '../types/results';
import ResultHeader from '../components/Results/ResultHeader';
import {useFeatureServices} from '../use-feature-services';
import questions from '../data/questions';

const ResultsContainer = styled.div``;

const Results = () => {
  const stat = useAppSelector((state) => state.result.value);
  const rankings = useAppSelector((state) => state.rankings.value);
  const navigatedFromSkip = useAppSelector((state) => state.page.navigatedFromSkip);

  const dispatch = useAppDispatch();
  const {tracking} = useFeatureServices();

  const totalSteps = Object.keys(questions).length;
  const resultStepNumber = totalSteps + 2;

  useEffect(() => {
    if (navigatedFromSkip) {
      tracking.track('VWBasic_Step_Pageload', {
        eventInfo: {
          pageCategory: 'Results',
          brand: "passenger"
        },
        process: {
          Name: 'SUVW Questionnaire and Lead Capture Form',
          StepName: 'Results Page - After Skip',
        },
      });

      dispatch(clearSkipFlag());
    }
  }, [navigatedFromSkip, dispatch, tracking, resultStepNumber]);

  return stat ? (
    <ResultsContainer>
      {stat ? <ResultHeader stat={stat} /> : null}
      {stat ? <ResultModel result={stat.result as ResultModelType } /> : null}
      {rankings ? <ResultRecommendation rankings={rankings} /> : null}
    </ResultsContainer>
  ) : null;
};

export default Results;
